<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ props: { disabled: disableSubmit } }"
    @cancel="handleCancel"
    cancelText="关闭">
    <efs-md-group-price-list-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></efs-md-group-price-list-form>
  </j-modal>
</template>

<script>

  import EfsMdGroupPriceListForm from './EfsMdGroupPriceListForm'
  export default {
    name: 'EfsMdGroupPriceListModal',
    components: {
      EfsMdGroupPriceListForm
    },
    data () {
      return {
        title:'',
        width:800,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          if(this.$t('button.edit')===this.title){
            this.$refs.realForm.isMmCodeDisabled=true;
            this.$refs.realForm.isMmCategoryDisabled=true;
            this.$refs.realForm.isMmNameDisabled=true;
            this.$refs.realForm.isSpecDisabled=true;
            this.$refs.realForm.isModelDisabled=true;
            this.$refs.realForm.isUnitDisabled=true;
            this.$refs.realForm.isValidFlagDisabled=true;
          }
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
        this.$refs.realForm.isMmCodeDisabled=false;
        this.$refs.realForm.isMmCategoryDisabled=false;
        this.$refs.realForm.isMmNameDisabled=false;
        this.$refs.realForm.isSpecDisabled=false;
        this.$refs.realForm.isModelDisabled=false;
        this.$refs.realForm.isUnitDisabled=false;
        this.$refs.realForm.isValidFlagDisabled=false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>